<template>
	<div class="only-mobile">
		<ul class="footer__menu d-lg-none">
			<div class="md-layout hidden"></div>
			<li>
				<router-link to="/" class="d-grid justify-content-center">
				  <md-icon>home</md-icon>
				  <span class="texta">{{$store.state.lang.text.home[$store.state.lang.language]}}</span>
				</router-link>
		  </li>
		  <li>
				<router-link to="/account/deposit" class="d-grid justify-content-center">
					  <md-icon>payments</md-icon>
					  <span class="texta">{{$store.state.lang.text.deposit[$store.state.lang.language]}}</span>
				</router-link>
		  </li>
		  <li>
			  <router-link to="/page/contact"><img src="@/assets/img/banners/contact.png" style="height: 45px"></router-link>
		  </li>
		  <li>
				<router-link to="/page/promotions" class="d-grid justify-content-center">
				  <md-icon>redeem</md-icon>
					 <span class="texta">{{$store.state.lang.text.promotion[$store.state.lang.language]}}</span>
				</router-link>
		  </li>
		  <li>
				<router-link to="/account_menu" class="d-grid justify-content-center">
				  <md-icon>account_circle</md-icon>
				  <span class="texta">{{$store.state.lang.text.my_account[$store.state.lang.language]}}</span>
				</router-link>
		  </li>
			<div class="md-layout hidden"></div>

	  </ul>
	</div>


</template>
<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
		}
	}
</script>

<style>
@media only screen and (max-width: 600px) {
  .hidden {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BottomMenu.vue